"use client";
import ContainerLayout from "@/layouts/ContainerLayout";
import { useState } from "react";
import videoMask from "../../../public/video_mask.webp";

const VideoSection = () => {
  const [showVideo, setShowVideo] = useState(false);
  const [activeVideo, setActiveVideo] = useState(1);

  return (
    <section>
      <ContainerLayout>
        <div className="relative mb-[16rem]">
          <div className="w-full aspect-video">
            <img
              alt=""
              src={videoMask.src}
              className={`w-full hover:cursor-pointer hover:scale-[.97] transition-transform h-full ${
                showVideo ? "hidden" : "block"
              }`}
              onClick={() => setShowVideo(true)}
            />
            {
              <div
                className={`${showVideo ? "block" : "hidden"} h-full w-full`}
              >
                {showVideo && activeVideo === 1 && (
                  <iframe
                    src="https://www.youtube.com/embed/Ct7s1NecSxI?si=GIQBEO4euZ_9ik5o&autoplay=1"
                    width="100%"
                    height="100%"
                    allowFullScreen
                    allow="autoplay"
                  ></iframe>
                )}
                {showVideo && activeVideo === 2 && (
                  <iframe
                    src="https://www.youtube.com/embed/mzrkH5NL-BI?si=sVkZ6PlqtBbzvjun&autoplay=1"
                    width="100%"
                    height="100%"
                    allowFullScreen
                    allow="autoplay"
                  ></iframe>
                )}
                {showVideo && activeVideo === 3 && (
                  <iframe
                    src="https://www.youtube.com/embed/sTtfKqiG0Fc?si=DietOQAp542zV3hn&autoplay=1"
                    width="100%"
                    height="100%"
                    allowFullScreen
                    allow="autoplay"
                  ></iframe>
                )}
              </div>
            }
          </div>
          <div className="absolute bottom-0 lg:translate-y-1/2 translate-y-full -translate-x-1/2 left-1/2 z-20 flex lg:gap-10 gap-4 flex-col lg:flex-row pt-4 lg:mt-0">
            <button
              className={`${
                activeVideo === 1 ? "btn-secondary" : "btn-tertiary"
              } whitespace-nowrap`}
              onClick={() => setActiveVideo(1)}
            >
              <span className="skew-x-[35deg] block">Edycja I</span>
            </button>
            <button
              className={`${
                activeVideo === 2 ? "btn-secondary" : "btn-tertiary"
              } whitespace-nowrap`}
              onClick={() => setActiveVideo(2)}
            >
              <span className="skew-x-[35deg] block">Edycja II</span>
            </button>
            <button
              className={`${
                activeVideo === 3 ? "btn-secondary" : "btn-tertiary"
              } whitespace-nowrap`}
              onClick={() => setActiveVideo(3)}
            >
              <span className="skew-x-[35deg] block">Edycja III</span>
            </button>
            <a
              href="https://www.youtube.com/playlist?list=PLOGpziB8FyYa0bj42cX1laX_8HNyieSqo"
              className="btn-tertiary whitespace-nowrap"
              target=""
            >
              <span className="skew-x-[35deg] block">Więcej na YouTube</span>
            </a>
          </div>
        </div>
      </ContainerLayout>
    </section>
  );
};

export default VideoSection;
